import { render, staticRenderFns } from "./down-arrow.vue?vue&type=template&id=501c8ba4&lang=pug&"
import script from "./down-arrow.vue?vue&type=script&lang=js&"
export * from "./down-arrow.vue?vue&type=script&lang=js&"
import style0 from "./down-arrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501c8ba4')) {
      api.createRecord('501c8ba4', component.options)
    } else {
      api.reload('501c8ba4', component.options)
    }
    module.hot.accept("./down-arrow.vue?vue&type=template&id=501c8ba4&lang=pug&", function () {
      api.rerender('501c8ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/down-arrow.vue"
export default component.exports